import prettyMs from 'pretty-ms';

/**
 * Formats a timestamp to a localized date/time string with timezone
 * @param timestamp - The timestamp to format (string or Date object)
 * @returns Formatted date/time string with timezone, or empty string if no timestamp provided
 */
export const formatTimestamp = (timestamp?: string | Date): string => {
  if (!timestamp) return '';
  return new Date(timestamp).toLocaleString(undefined, {
    timeZoneName: 'short'
  });
};

/**
 * Formats duration in milliseconds to a human-readable duration string
 * @param durationInMs - The duration in milliseconds
 * @returns Formatted duration string (e.g., "1h 30m 45s", "1d 30m 45s", "133ms")
 */
export const formatDuration = (durationInMs?: number): string => {
  if (!durationInMs) return '';
  
  return prettyMs(durationInMs, {
    secondsDecimalDigits: 0,
    separateMilliseconds: false
  });
};
